import React from 'react';
import { css } from 'aphrodite';
import styles from './styles';
import { useIsUnifiedPlatform } from '~/src/entities/user/hooks/useFeatureAccess';

const HelpMenu = () => {
  const isUnifiedPlatform = useIsUnifiedPlatform();

  const helpCenterUrl = isUnifiedPlatform
    ? 'https://help.clio.com/hc/en-us/sections/22374693662235-Clio-Draft'
    : 'https://help.draftlegacy.clio.com';

  return (
    <>
      <a
        className={css(styles.menuLink)}
        href={helpCenterUrl}
        target="_blank"
        rel="noreferrer"
      >
        Help center
      </a>
      <a
        className={css(styles.menuLink)}
        href="https://vimeo.com/showcase/11299388"
        target="_blank"
        rel="noreferrer"
      >
        Video Library
      </a>
    </>
  );
};
export default HelpMenu;
